<section id="customers">
  <div class="our-customers-box">
    <div class="container">
      <h2 class="section-title">{{"clients.title" | translate}}</h2>
      <p class="note">{{"clients.note" | translate}}</p>
      <div class="customers-wrap">
        <div class="customer" *ngFor="let customer of customers">
          <a>
            <img [src]="customer.logo " [alt]="customer.title" width="150" loading="lazy"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
